import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MatDialog, MatTableDataSource, MatSort, Sort, MatIconRegistry, PageEvent } from '@angular/material';
import { DialogComponent } from '../../change-password/dialog/dialog.component';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { regExps, OapStandarErrorStateMatcher, errorMessages, OapErrorMessages } from '../../custom-validators/custom-validators.module';
import { SearchElement, GestionnaireService, ProcessDocument } from '../gestionnaire.service';
import { first, tap, min } from 'rxjs/operators';
import { SelectionModel } from '@angular/cdk/collections';
import { DomSanitizer } from '@angular/platform-browser';
import { UploadService } from '../../../upload/upload.service';
import { DatePipe } from '@angular/common';
import { DetailPatientComponent } from '../detail-patient/detail-patient.component';
import { OapHtmlDownloadFile } from '../../../helpers/oap-html-download-file';
import { AuthToken } from '../../../models/authToken';
import { Gestionnaire } from '../../../models/gestionnaire';
import { CommentaireSurPatientComponent } from '../commentaire-sur-patient/commentaire-sur-patient.component';
import { ConfirmDialogService } from '../shared/confirm-dialog.service';
import { AlertService } from 'src/app/services/alert.service';

export interface SearchResultData {
  patient_key: number;
  patient: string;
  date_naissance: Date;
  code_medecin: string;
  nom_medecin: string;
  numero_ordonnance: number;
  date_ordonnance: Date;
  date_depot: Date;
  type_document: string;
  nom_document: string;
  mime_type_document: string;
  infos_document: InfoDocumentData;
  documentTraite: Boolean;
  nomGestionnaire: string;
  avecCommentaire: boolean;
  gedRunId: number;
  dateTransmissionGed: Date;
  validationCgu: boolean;
}

export interface InfoDocumentData {
  document_key: number;
  type_document: string;
  nom_document: string;
  mime_type_document: string;
}


@Component({
  selector: 'oap-gest-home',
  templateUrl: './gest-home.component.html',
  styleUrls: ['./gest-home.component.scss']
})
export class GestHomeComponent implements OnInit {
  searchForm: FormGroup;
  submitted = false;
  authToken: AuthToken;
  currentGestionnaire: Gestionnaire;

  displayedColumns: string[] = ['patient', 'date_naissance', 'code_medecin', 'nom_medecin', 'numero_ordonnance', 'date_ordonnance', 'date_depot', 'type_document', 'nom_document', 'actions', 'documentTraite', 'nomGestionnaire'];
  dataSource: MatTableDataSource<SearchResultData>;
  loading = false;
  results: SearchResultData[] = [];
  heureImpressionValues: string[] = ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '12:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00' ];

  matcher = new OapStandarErrorStateMatcher();
  errors = errorMessages;
  validation_messages = OapErrorMessages;

  selection = new SelectionModel<SearchResultData>(true, []);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('myDiv') myBut: ElementRef;

  // information pour le paginator
  paginatorTotalLength = 100;
  pageSize = 50;
  pageOffset = 0;
  pageIndex = 0;
  pageSizeOptions: number[] = [8, 16, 32, 50, 100];
  numColTri = 2; // numéro de la colonne à trié
  directionTri = 'asc'; // asc ou desc
  viewDocumentAllow = true; // autorise la vue des documents
  btnDeleteAllow = false; // autorise la suppression de document

  btnSendBackEmailAllow= false;

  minHeureImpression = 6;
  maxHeureImpression = 19;

  // MatPaginator Output
  pageEvent: PageEvent;

  tooltip_view_document = 'Voir le document';
  tooltip_delete_document = 'Supprimer le document';
  tooltip_download_document = 'Télécharger le document';
  tooltip_detail_patient = 'Informations patient';
  tooltip_comments = 'Commentaires';
  tooltip_email_bienvenue = 'Renvoi du mail de bienvenue';
  tooltip_email_reset_password = 'Réinitialisation du mot de passe';

  label_silde_doc_traite = 'Afficher tous les documents';
  label_silde_patient_document = 'Afficher tous les patients';

  tooltip_resetGed = 'Réinitialiser l\'indicateur GED';

  viewButtonExport = false; // autorise la vue du boutton export excel
  viewButtonTreated = false; // autorise la vue du boutton Marquer comme traité

  constructor(public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private gestionnaireService: GestionnaireService,
    private messageService: MessageService,
    private alertService: AlertService,
    private uploadService: UploadService,
    private oapHtmlDownloadFile: OapHtmlDownloadFile,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private confirmDialogService: ConfirmDialogService) {
    iconRegistry.addSvgIcon('eye', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-remove_red_eye-24px.svg'));
    iconRegistry.addSvgIcon('saveAs', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-save_alt-24px.svg'));
    iconRegistry.addSvgIcon('pageview', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-pageview-24px.svg'));
    iconRegistry.addSvgIcon('without_comments', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-description-24px.svg'));
    iconRegistry.addSvgIcon('with_comments', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/baseline-description-24px.svg'));
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-clear-24px.svg'));
    iconRegistry.addSvgIcon('delete_document', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-delete-24px.svg'));
    iconRegistry.addSvgIcon('reset_ged', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-cached-24px.svg'));
    iconRegistry.addSvgIcon('mail', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/forward_to_inbox_black_24dp.svg'));
    iconRegistry.addSvgIcon('reset_password', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/password_black_24dp.svg'));
    

      this.authToken = JSON.parse(localStorage.getItem('currentUser'));
      // console.log(' id :' + this.authToken.id);

    if (this.authToken.type === 'T') {
      this.viewDocumentAllow = false;
      this.btnSendBackEmailAllow = true;
    }

    if (this.authToken.type === 'V') {
      this.btnDeleteAllow = true;
    }
  }

  ngOnInit() {
    this.messageService.sendMessage('page-gestionnaire');
    this.alertService.clear();

    this.gestionnaireService.getGestionnaireByCptKey(this.authToken.id).pipe(first()).subscribe(ges => {
      if (ges) {
        const gestionnaires: Gestionnaire[] = ges;
        this.currentGestionnaire = gestionnaires[0];
      }
    });

    const date = new Date();
    date.setDate(date.getDate() - 10);
    const datePipe = new DatePipe('en-US');
    const nowMinus10 = datePipe.transform(date, 'yyyy-MM-dd');

    this.searchForm = this.formBuilder.group({
      lastName: ['', Validators.maxLength(40)],
      firstName: ['', [Validators.maxLength(40),
      Validators.pattern(regExps.onlyLettersAccent)]],
      numeroSS: ['', Validators.maxLength(15)],
      telPatient: ['', Validators.maxLength(10)],
      codeMedecin: ['', Validators.maxLength(40)],
      numeroOrdonnance: ['', Validators.maxLength(40)],
      dateOrdonnanceDu: ['', ],
      dateOrdonnanceAu: ['', ],
      dateDepotDu: [nowMinus10, ],
      dateDepotAu: ['', ],
      avecPatientSansDocument: ['', ],
      avecDocumentTraite: ['', ],
      uniquementErreurGed: ['', ],
      dateImpression: ['', ],
      heureImpression: ['', [Validators.min(this.minHeureImpression),
        Validators.max(this.maxHeureImpression),
        Validators.pattern(regExps.onlyDigits)]],
    });

    this.searchForm.patchValue(
      {
        avecPatientSansDocument: false,
        avecDocumentTraite: false,
        uniquementErreurGed: false
      });

    this.onFormSubmit(this.searchForm);
  }

  ngAfterViewInit() {
    const compteExpire = JSON.parse(localStorage.getItem('compte-expire'));
    if (compteExpire === 'true') {
      this.dialog.open(DialogComponent,
        {
          disableClose: true,
          data: { expired: true }
        });
      localStorage.setItem('compte-expire', 'false');

      //this.dataSource.sort = this.sort;
    }
  }

  onFormSubmit(form: FormGroup) {
    this.alertService.clear();

    this.submitted = true;
    this.loading = true;
    this.viewButtonExport = false;
    this.viewButtonTreated = false;

    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    const searchElement = this.getSearchElement();

    this.doServiceSearch(searchElement);

  }

  private doServiceSearch(aSearchElement: SearchElement) {
    this.gestionnaireService.search(aSearchElement)
      .pipe(first())
      .subscribe(
        data => {

          this.pageOffset = data.pageOffset;
          this.pageSize = data.limit;
          this.paginatorTotalLength = data.totalElements;

          this.results = [];
          data.elements.forEach(element => {
            this.results.push(createSearchResultData(element));
          });
          // console.log(" results count : " +  this.results.length );
          this.dataSource = new MatTableDataSource(this.results);

          if (this.results.length > 0) {
            this.viewButtonExport = true;
            this.viewButtonTreated = true;
          }

        },
        error => {
          console.error(error);
        },
        () => { this.loading = false; });
  }

  private getSearchElement(): SearchElement {
    const datePipe = new DatePipe('en');

    return {
      nom: this.searchForm.controls.lastName.value,
      prenom: this.searchForm.controls.firstName.value,
      numeroSS: this.searchForm.controls.numeroSS.value,
      telPatient: this.searchForm.controls.telPatient.value,
      codeMedecin: this.searchForm.controls.codeMedecin.value,
      numeroOrdonnance: this.searchForm.controls.numeroOrdonnance.value,
      dateOrdonnanceDu: datePipe.transform(this.searchForm.controls.dateOrdonnanceDu.value, 'yyyy-MM-dd'),
      dateOrdonnanceAu: datePipe.transform(this.searchForm.controls.dateOrdonnanceAu.value, 'yyyy-MM-dd'),
      dateDepotDu: datePipe.transform(this.searchForm.controls.dateDepotDu.value, 'yyyy-MM-dd'),
      dateDepotAu: datePipe.transform(this.searchForm.controls.dateDepotAu.value, 'yyyy-MM-dd'),
      dateImpression: datePipe.transform(this.searchForm.controls.dateImpression.value, 'yyyy-MM-dd'),
      heureImpression: this.searchForm.controls.heureImpression.value,
      avecPatientSansDocument: this.searchForm.controls.avecPatientSansDocument.value,
      avecDocumentTraite: !this.searchForm.controls.avecDocumentTraite.value,
      uniquementErreurGed: this.searchForm.controls.uniquementErreurGed.value,
      numColTri: this.numColTri,
      limit: this.pageSize, // nombre de ligne dans une page
      pageOffset: 0, // décalage par rapport au début
      directionTri: this.directionTri,
      gestionnaireKey: null
    };

  }

  onPageEvent(event: PageEvent) {
    this.alertService.clear();

    this.pageOffset = event.pageIndex;
    this.pageSize = event.pageSize;

    const searchElement = this.getSearchElement();

    searchElement.numColTri = this.numColTri;
    searchElement.limit = event.pageSize; // nombre de ligne dans une page
    searchElement.pageOffset = event.pageIndex; // décalage par rapport au début
    searchElement.directionTri = this.directionTri;
    searchElement.gestionnaireKey = this.currentGestionnaire.gestionnaireKey;

    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.doServiceSearch(searchElement);
  }

  sortData(sort: Sort) {
    this.alertService.clear();
    this.directionTri = sort.direction;

    switch (sort.active) {
      case 'patient':
        this.numColTri = 2;
        break;
      case 'date_depot':
        this.numColTri = 9;
        break;
      default:
        this.numColTri = 2;
        break;
    }
    this.onFormSubmit(this.searchForm);
  }

  viewDocument(document: SearchResultData) {
    this.downloadFile(document, false);
  }

  downloadDocument(document: SearchResultData) {
    this.downloadFile(document, true);
  }

  sendBackEmail(document: SearchResultData, typeMail: string) {
    this.alertService.clear();

    this.confirmDialogService.openConfirmDialog('Le mail ' + typeMail + ' va être envoyer au patient.')
    .afterClosed().subscribe(res => {
      if (res) {
        this.gestionnaireService.sendBackEmail(document.patient_key).pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Le mail ' + typeMail + ' a été envoyé.', false);
                    const searchElement = this.getSearchElement();
                    this.doServiceSearch(searchElement);
               },
                error => {
                    console.log(error);
                    this.alertService.error('Une erreur est survenue, mail non envoyé.', false);
                }
            );
      }
    });
  }

  deleteDocument(document: SearchResultData) {
    this.alertService.clear();

    this.confirmDialogService.openConfirmDialog('Le document va être supprimer')
    .afterClosed().subscribe(res => {
      if (res) {
        this.uploadService.delete(document.patient_key, document.infos_document.document_key).pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Confirmation fichier supprimé.', false);
                    const searchElement = this.getSearchElement();
                    this.doServiceSearch(searchElement);
               },
                error => {
                    console.log(error);
                    this.alertService.error('Une erreur est survenue, fichier non supprimé.', false);
                }
            );
      }
    });
  }

  resetGed(document: SearchResultData) {
    this.alertService.clear();

    this.confirmDialogService.openConfirmDialog('L\'indicateur GED va être réinitialisé pour ce document')
    .afterClosed().subscribe(res => {
      if (res) {
        this.gestionnaireService.resetGed(document.infos_document.document_key).pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Confirmation indicateur GED réinitialisé.', false);
                    this.doServiceSearch(this.getSearchElement());
               },
                error => {
                    console.log(error);
                    this.alertService.success('Une erreur est survenue, indicateur GED non réinitialisé.', false);
                }
            );
      }
    });
  }

  detailPatient(document: SearchResultData) {
    const dialogRef = this.dialog.open(DetailPatientComponent,
      { disableClose: false,
          data: { patientKey: document.patient_key}
    });
  }

  commentaireSurPatient(document: SearchResultData) {
    const dialogRef = this.dialog.open(CommentaireSurPatientComponent,
      {
        disableClose: true,
        data: { patientKey: document.patient_key },
        maxHeight: '600px',
        maxWidth: '800px',
        minHeight: '400px',
        minWidth: '600px',
      });

    dialogRef.afterClosed().subscribe(result => {
      document.avecCommentaire = false;
      if (result) {
        document.avecCommentaire = true;
      }
      this.classComment(document);
      this.iconComment(document);
    });
  }

  classComment(document: SearchResultData) {
    if (document.avecCommentaire) {
      return 'opa-icon-with-comments mat-icon';
    }
    return 'mat-icon';
  }

  classGed(document: SearchResultData) {
    if (document.gedRunId > 0) {
      return 'mat-cell cdk-column-nom_document mat-column-nom_document ged_ok ng-star-inserted';
    } else if (document.gedRunId === -1) {
      return 'mat-cell cdk-column-nom_document mat-column-nom_document before_ged ng-star-inserted';
    } else if (document.gedRunId === -99) {
      return 'mat-cell cdk-column-nom_document mat-column-nom_document ged_ko ng-star-inserted';
    }
    return 'mat-cell cdk-column-nom_document mat-column-nom_document ng-star-inserted';
  }

  tooltipGed(document: SearchResultData ) {
    if (document.dateTransmissionGed !== null) {
      return 'Transmis à la GED le ' + document.dateTransmissionGed;
    } else if (document.gedRunId === -99) {
        return 'Erreur de transmission vers la GED';
    }
    return '';
  }

  classDeleteDocument(document: SearchResultData) {
    if (document.infos_document.document_key != null) {
      return 'opa-icon-delete-document mat-icon';
    }
    return 'mat-icon';
  }

  iconComment(document: SearchResultData) {
    if (document.avecCommentaire) {
      return 'with_comments';
    }
    return 'without_comments';
  }

  tooltipComment(document: SearchResultData) {
    if (document.avecCommentaire) {
      return 'Commentaires';
    }
    return 'Aucun commentaires';
  }

  toggleDocumentTraite(document: SearchResultData) {
    document.documentTraite = !document.documentTraite;

    const processDocument: ProcessDocument = {
      documentKey: document.infos_document.document_key,
      gestionnaireKey: this.currentGestionnaire.gestionnaireKey,
      process: Boolean(document.documentTraite)
    };

    this.gestionnaireService.process(processDocument)
      .pipe(first())
      .subscribe(
        data => {
          if (document.documentTraite) {
            document.nomGestionnaire = this.currentGestionnaire.prenom + ' ' + this.currentGestionnaire.nom;
          } else {
            document.nomGestionnaire = null;
          }
        },
        error => {
          console.error(error);
        });

  }

  clearSearchForm() {
    this.searchForm.patchValue(
      {
        lastName: null,
        firstName: null,
        numeroSS: null,
        telPatient: null,
        codeMedecin: null,
        numeroOrdonnance: null,
        dateOrdonnanceDu: null,
        dateOrdonnanceAu: null,
        dateDepotDu: null,
        dateDepotAu: null,
        dateImpression: null,
        heureImpression: null,
        avecPatientSansDocument: false,
        avecDocumentTraite: false,
        uniquementErreurGed: false
      });

    this.onFormSubmit(this.searchForm);
    this.viewButtonExport = false;
    this.viewButtonTreated = false;

  }

  exportExcel() {
    const searchElement = this.getSearchElement();

    searchElement.numColTri = this.numColTri;
    searchElement.limit = this.pageSize; // nombre de ligne dans une page
    searchElement.pageOffset = 0; // décalage par rapport au début
    searchElement.directionTri = this.directionTri;
    searchElement.gestionnaireKey = this.currentGestionnaire.gestionnaireKey;

    this.gestionnaireService.exportExcel(searchElement)
      .subscribe(
        data => {
          const blob = new Blob([data.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const nomDoc = data.headers.get('oap-export-file-name');
          this.oapHtmlDownloadFile.downloadFileOnNavigator(blob, nomDoc, true);
        },
        error => {
          console.error(error);
        },
        () => { this.loading = false; }
      );
  }

  markAsTreated() {
    let msg = '';
    if (this.results.length === 1) {
      msg = 'Le document sélectionné sera marqué comme traité.';
    } else {
      msg = 'Les ' + this.results.length + ' documents sélectionnés seront marqués comme traité.';
    }

    this.confirmDialogService.openConfirmDialog(msg)
    .afterClosed().subscribe(res => {
      if (res) {
        this.doMarkAsTreated();
      }
    });
  }

  private doMarkAsTreated() {

    const searchElement = this.getSearchElement();

    searchElement.numColTri = this.numColTri;
    searchElement.limit = this.pageSize; // nombre de ligne dans une page
    searchElement.pageOffset = 0; // décalage par rapport au début
    searchElement.directionTri = this.directionTri;
    searchElement.gestionnaireKey = this.currentGestionnaire.gestionnaireKey;

    this.gestionnaireService.markAsTreated(searchElement)
    .pipe(first())
    .subscribe(
      data => {

        this.pageOffset = data.pageOffset;
        this.pageSize = data.limit;
        this.paginatorTotalLength = data.totalElements;

        this.results = [];
        data.elements.forEach(element => {
          this.results.push(createSearchResultData(element));
        });
        this.dataSource = new MatTableDataSource(this.results);

        if (this.results.length > 0) {
          this.viewButtonExport = true;
          this.viewButtonTreated = true;
        }

        this.searchForm.patchValue(
          {
            avecDocumentTraite: true
          }
        );

      },
      error => {
        console.error(error);
      },
      () => { this.loading = false; });
  }

  private downloadFile(document: SearchResultData, forDownload: boolean) {
    this.uploadService.download(document.infos_document.document_key, document.infos_document.mime_type_document).pipe(first())
      .subscribe(
        data => {
          const blob = new Blob([data], { type: document.infos_document.mime_type_document });

          // nom du document forme si le médecin existe  Code_Medecin_N° Ordo_Type_document
          // nom du document forme sinon Code_Medecin_N° Ordo_Type_document
          let nomDoc = document.infos_document.nom_document;
          if (document.code_medecin) {
            const idx = document.infos_document.nom_document.lastIndexOf('.');
            const extension = document.infos_document.nom_document.substring(idx);
            nomDoc = document.code_medecin + '_' + document.numero_ordonnance + '_' + document.infos_document.type_document + extension;
            nomDoc = nomDoc.replace(' ', '_');
          }

          this.oapHtmlDownloadFile.downloadFileOnNavigator(blob, nomDoc, forDownload);

        },
        error => console.log('Error downloading the file : ' + error),
        () => console.log('Completed file download.')
      );
  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

/** Builds and returns a new SearchResultData. */
function createSearchResultData(data: any): SearchResultData {

  const infoDoc: InfoDocumentData = {
    document_key: data.documentKey,
    type_document: data.typeDocument,
    nom_document: data.nomDocument,
    mime_type_document: data.documentMimeType
  };

  return {
    patient_key: data.patientKey,
    patient: data.nomPatient + '  ' + data.prenomPatient,
    date_naissance: data.dateNaissance,
    code_medecin: data.codeMedecin,
    nom_medecin: data.nomMedecin,
    numero_ordonnance: data.numeroOrdonnance,
    date_ordonnance: data.dateOrdonnance,
    date_depot: data.dateDepot,
    type_document: data.typeDocument,
    nom_document: data.nomDocument,
    mime_type_document: '',
    infos_document: infoDoc,
    documentTraite: data.documentTraite,
    nomGestionnaire: data.nomGestionnaire,
    avecCommentaire: data.avecCommentaire,
    gedRunId: data.gedRunId,
    dateTransmissionGed: data.dateTransmissionGed,
    validationCgu: data.validationCgu
  };
}
